import { ContractType, EmploymentSituationName } from './enums';

export class EmployerName {
  constructor(public readonly value: string) {}
}

export class IncomingSource {
  constructor(public readonly value: string) {}
}

export class Employed {
  private readonly _employerName: EmployerName;
  private readonly _contractType: ContractType;
  constructor(public readonly employerName: EmployerName, public readonly contractType: ContractType) {
    this._employerName = employerName;
    this._contractType = contractType;
  }

  get() {
    return {
      name: EmploymentSituationName.EMPLOYED,
      employerName: this._employerName.value,
      contractType: this._contractType,
    };
  }
}

export class Unemployed {
  private readonly _incomingSource: IncomingSource;
  constructor(public readonly incomingSource: IncomingSource) {
    this._incomingSource = incomingSource;
  }
  get() {
    return {
      name: EmploymentSituationName.UNEMPLOYED,
      incomingSource: this._incomingSource.value,
    };
  }
}

export class Independent {
  private readonly _incomingSource: IncomingSource;
  constructor(public readonly incomingSource: IncomingSource) {
    this._incomingSource = incomingSource;
  }
  get() {
    return {
      name: EmploymentSituationName.INDEPENDENT,
      incomingSource: this._incomingSource.value,
    };
  }
}

export class Rentier {
  private readonly _incomingSource: IncomingSource;
  constructor(public readonly incomingSource: IncomingSource) {
    this._incomingSource = incomingSource;
  }
  get() {
    return {
      name: EmploymentSituationName.RENTIER,
      incomingSource: this._incomingSource.value,
    };
  }
}

export class LegalPerson {
  private readonly _incomingSource: IncomingSource;
  constructor(public readonly incomingSource: IncomingSource) {
    this._incomingSource = incomingSource;
  }
  get() {
    return {
      name: EmploymentSituationName.LEGAL_PERSON,
      incomingSource: this._incomingSource.value,
    };
  }
}

export type EmploymentSituation = Employed | Unemployed | Independent | Rentier | LegalPerson;
